import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import UpdateRequest from './UpdateRequest';
import { 
  getoffRoleEmployeesData, 
  getDataForDropdown, 
  updateStatusOffroleEmployee,
  getLocationMappingByUserId,
  getTeamMappingByUserId,
  citiesDropdownData,
  zonesDropdownData,
  departmentDropdownData,
  teamDropdownData,
  areasDropdownData,
  reportingManagerDropdownData,
  assignLocationsToUser,
  assignReporteeToUser,
  deleteUserMappingRequest 
} from 'services/redux/OffRoleEmployees/action';

const mapStateToProps = (state) => ({
    getEmployeesListing: state.offroleEmployeesReducer.getEmployeesListing,
    getDropdownDatas: state.offroleEmployeesReducer.getDropdownDatas,
    statusUpdationByBusinessHead: state.offroleEmployeesReducer.statusUpdationByBusinessHead,
    getLocationMappingByUserIdResponse: state.offroleEmployeesReducer.getLocationMappingByUserIdResponse,
    getTeamMappingByUserIdResponse: state.offroleEmployeesReducer.getTeamMappingByUserIdResponse,
    departmentDropwdownResponse: state.offroleEmployeesReducer.departmentDropwdownResponse,
    teamDropdownResponse: state.offroleEmployeesReducer.teamDropdownResponse,
    roleDropdownResponse: state.offroleEmployeesReducer.roleDropdownResponse,
    reportingManagerResponse: state.offroleEmployeesReducer.reportingManagerResponse,
    citiesDropdownResponse: state.offroleEmployeesReducer.citiesDropdownResponse,
    zonesDropdownResponse: state.offroleEmployeesReducer.zonesDropdownResponse,
    areasDropdownResponse: state.offroleEmployeesReducer.areasDropdownResponse,
    deleteUserMappingResponse: state.offroleEmployeesReducer.deleteUserMappingResponse
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
        getoffRoleEmployeesData,
        getDataForDropdown,
        updateStatusOffroleEmployee,
        getLocationMappingByUserId,
        getTeamMappingByUserId,
        citiesDropdownData,
        zonesDropdownData,
        departmentDropdownData,
        teamDropdownData,
        areasDropdownData,
        reportingManagerDropdownData,
        assignLocationsToUser,
        assignReporteeToUser,
        deleteUserMappingRequest
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(UpdateRequest);
